import script from "./clockDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./clockDisplay.vue?vue&type=script&setup=true&lang=js"

import "./clockDisplay.vue?vue&type=style&index=0&id=67944a3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67944a3b"]])

export default __exports__